<template>
  <div class="container clinic-config">
    <div class="row mt-5 mb-4">
      <div class="col">
        <h1 class="page-title">CONFIGURACION AVANZADA</h1>
      </div>
      <div class="col">
        <div class="btn btn-wabident float-right" @click="saveConfig" :disabled="is_saving">Guardar</div>
      </div>
    </div>

    <div v-for="(opts, category) in grouped_options" class="row" :key="category">
      <div class="col-md-12 mb-4 py-3" style="border-bottom: 1px var(--theme-grey) solid">
        <h4><strong>{{ category }}</strong></h4>
      </div>
      <div v-for="option in opts" class="col-md-12 mb-3" :key="option.id">
        <div v-if="option.type == 'number'">
          <label :for="option.slug" class="wabident-info">{{ option.description }}</label>
          <input class="form-control" type="number" :value="getOption(option)" :id="option.slug"
            @input="setOption(option, $event.target.value)">
        </div>
        <div v-else-if="option.type == 'string'">
          <label :for="option.slug" class="wabident-info">{{ option.description }}</label>
          <input class="form-control" type="text" :value="getOption(option)"
            @input="setOption(option, $event.target.value)">
        </div>
        <div v-else-if="option.type == 'boolean'">
          <div class="form-check form-check-inline">
            <input class="form-check-input" :id="option.slug" type="checkbox" :value="true" :checked="getOption(option)"
              @input="setOption(option, $event.target.checked)">
            <label class="form-check-label" :for="option.slug"> {{ option.description }}</label>
          </div>
        </div>
        <div v-else-if="option.type == 'array'">
        </div>
        <div v-else-if="option.type == 'object'">
          <label class="mb-2">
            <strong>{{ option.description }}</strong>
          </label>

          <object-field :slug="option.slug" :object="getOption(option)" @add="(k, v) => addOption(option, k, v)"
            @delete="(k) => deleteOptionKey(option, k)"></object-field>
        </div>
        <div class="mt-2">
          <small><code>{{ option.slug }}</code> - {{ option.type }}</small>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ['cid', 'clinic_info', 'config_options'],
  data() {
    return {
      clinic: null,
      is_saving: false,
      tmp_key: null,
      tmp_value: null,
      options: [],
    };
  },
  computed: {
    grouped_options() {
      let ret = {};

      this.options.forEach((option) => {
        ret[option.category] = ret[option.category] || [];
        ret[option.category].push(option);
      });

      return ret;
    },
    ...mapGetters(['msgwindow'])
  },
  methods: {
    deleteOptionKey(option, key) {
      let current_value = this.clinic.config[option.slug] || {};
      if (!WabiDent.isObject(current_value)) {
        current_value = {};
      }

      current_value[key] = undefined;
      delete current_value[key];

      this.$set(this.clinic.config, option.slug, current_value);
    },
    addOptionKey(option) {
      this.addOption(option, this.tmp_key, this.tmp_value);
      this.tmp_key = null;
      this.tmp_value = null;
    },
    addOption(option, key, value) {
      let current_value = this.clinic.config[option.slug] || {};
      if (!WabiDent.isObject(current_value)) {
        current_value = {};
      }
      current_value[key] = value;
      this.$set(this.clinic.config, option.slug, current_value);
    },
    getOption(option) {
      if (this.clinic && this.clinic.config) {
        let val = this.clinic.config[option.slug];
        if (typeof val !== 'undefined') {
          return val;
        };
      }
      return null;
    },
    setOption(option, value) {
      if (this.clinic && this.clinic.config) {
        switch (option.type) {
          case 'number':
            value = Number(value);
            break;
          case 'string':
            value = String(value);
            break;
          case 'boolean':
            value = Boolean(value);
            break;
        }

        this.$set(this.clinic.config, option.slug, value);
      }
    },
    saveConfig() {
      if (this.is_saving) return;
      this.is_saving = true;
      axios.post(`/clinic/${this.cid}/config`,
        {
          cfg: this.clinic.config
        }
      ).then(response => {
        this.msgwindow.success('Guardado');
      }).catch(error => {
        this.msgwindow.error('Error');
      }).then(() => {
        this.is_saving = false;
      });
    },
  },
  beforeMount() {
    this.clinic = JSON.parse(this.clinic_info);
    this.options = JSON.parse(this.config_options);
  },
};
</script>

<style lang="scss">
.clinic-config {
  &__list {
    table {
      th {
        font-size: 15px;
        letter-spacing: 0.3px;
        color: var(--theme-grey);
        border: none;
        position: sticky;
        top: 0;
        z-index: 1;
        background: white;
        border-bottom: 1px #e0e0e0 solid;
      }

      &__row {
        cursor: pointer;
        background-color: transparent;
        transition: all 0.2s;
        border-bottom: 1px #e0e0e0 solid;
        border-top: 1px #e0e0e0 solid;

        &:hover {
          background-color: var(--theme-highlight);
        }

        td {
          font-size: 16px;
          line-height: 20px;
          color: var(--theme-text-color);
        }
      }
    }
  }
}
</style>
